import styled from '@emotion/styled';
import Box from './Box';

function GetIEVersion() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf('MSIE');

  // If IE, return version number.
  if (Idx > 0)
    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)));
  // If IE 11 then look for Updated user agent string.
  else if (navigator.userAgent.match(/Trident\/7\./)) return 11;
  else return 0; //It is not IE
}

const ieMediaQuery =
  '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)';

const createMediaQueryString = (breakpoints, breakpoint) => {
  const bp = breakpoints[breakpoint];
  return `${ieMediaQuery}, (min-width: ${bp})`;
};

const createIeRules = (mediaQuery, props) => {
  const rule = {
    [mediaQuery]: {
      display: '-ms-grid',
      msGridRows: props.gridTemplateRows,
      msGridColumns: props.gridTemplateColumns,
      msGridRow: props.gridRow,
      msGridColumn: props.gridColumn,
      '> div': {
        paddingTop:
          (props.theme.space[props.gridGap] ||
            props.theme.space[props.gridRowGap]) + 'px',
        paddingRight:
          (props.theme.space[props.gridGap] ||
            props.theme.space[props.gridColumnGap]) + 'px',
      },
    },
  };
  return rule;
};

const Grid = styled(Box)((props) => {
  let cssRules = {
    display: 'grid',
  };
  let ieRules = {};
  if (GetIEVersion() > 0) {
    if (typeof props.gridRow === 'object') {
      Object.keys(props.gridRow).forEach((breakpoint) => {
        const mediaQuery = createMediaQueryString(
          props.theme.breakpoints,
          breakpoint
        );
        var updatedProps = { ...props };
        updatedProps.gridRow = props.gridRow[breakpoint];
        updatedProps.gridColumn = props.gridColumn[breakpoint];
        ieRules = createIeRules(mediaQuery, updatedProps);
      });
    } else {
      ieRules = createIeRules(ieMediaQuery, props);
    }
  }

  return { ...cssRules, ...ieRules };
});

export default Grid;
